import React, { useState, useEffect } from "react";
import { forwardRef, useImperativeHandle } from 'react';
import ExpandableSection from "../../expandablesection";
import SillType from "./SillType";
import SillFinish from "./SillFinish";
import SillSize from "./SillSize";
import SillHorn from "./SillHorn";

//const PanelSill = ({ onChange }) => {
const PanelSill = forwardRef(({ onChange }, ref) => {
  const [sillTypeValue, setSillTypeValue] = useState("");
  const [sillFinishValue, setSillFinishValue] = useState("");
  const [sillSizeValue, setSillSizeValue] = useState("");
  const [sillHornValue, setSillHornValue] = useState("");



 // Method to retrieve all active controls and their values
  const getActiveControlsWithValues = () => {
    const values = {};

    controlMap
      .filter((control) => control.status === "active") // Only active controls
      .forEach((control) => {
        const element = document.getElementById(control.id); // Query by control ID
        if (element) {
          values[control.id] = element.value; // Retrieve the current value
        } else {
          values[control.id] = null; // Handle missing elements
        }
      });

    return values;
  };

  // Expose the `getActiveControlsWithValues` method to the parent via ref
  useImperativeHandle(ref, () => ({
    getActiveControlsWithValues,
  }));
  // Notify parent component whenever values change
  useEffect(() => {
    onChange({
      sillType: sillTypeValue,
      sillFinish: sillFinishValue,
      sillSize: sillSizeValue,
      sillHorn: sillHornValue,
    });
  }, [sillTypeValue, sillFinishValue, sillSizeValue, sillHornValue,
      onChange]);

   // Control map specific to SillPanel
   const controlMap = [
    {
        id: "SillType",
        component: (
          <SillType
            onChange={(newValue) => {
              setSillTypeValue(newValue);
            }}
            childs={["SillFinish", "SillSize", "SillHorn" ]}
          />
        ),
        position: [1, 1],
        status: "active",
        expandableSectionId: "SillPanel",
      }, 
      {
        id: "SillFinish",
        component: (
          <SillFinish
            onChange={(newValue) => {
              setSillFinishValue(newValue);
            }}
          />
        ),
        position: [1, 2],
        status: "active",
        expandableSectionId: "SillPanel",
      }, 
      {
        id: "SillSize",
        component: (
          <SillSize
            onChange={(newValue) => {
              setSillSizeValue(newValue);
            }}
          />
        ),
        position: [1, 3],
        status: "active",
        expandableSectionId: "SillPanel",
      },  
      {
        id: "SillHorn",
        component: (
          <SillHorn
            onChange={(newValue) => {
              setSillHornValue(newValue);
            }}
          />
        ),
        position: [2, 1],
        status: "active",
        expandableSectionId: "SillPanel",
      },  
];


return (
  <ExpandableSection
    title="Sill"
    panelLocation="112"
    controlMap={controlMap.filter((control) => control.expandableSectionId === "SillPanel")}
  />
);
});

//);
//};

export default PanelSill;
